
import { defineComponent } from 'vue'
import ModalBase from '@/views/modal/ModalBase.vue'

export default defineComponent({
  name: 'ConfirmDeleteDraft',
  components: {
    ModalBase
  },
  emits: {
    dismiss: () => true,
    deleteSlip: (serialNo: number) => true
  },
  props: {
    serialNo: {
      type: Number,
      required: false
    },
    deliveryDate: {
      type: String,
      required: false
    }
  },
  setup (props, { emit }) {
    const dismiss = () => {
      emit('dismiss')
    }

    const deleteSlip = () => {
      if (props.serialNo) {
        emit('deleteSlip', props.serialNo)
      }
    }

    return {
      dismiss,
      deleteSlip
    }
  }
})
